// Schedule-D commercial model (see CONTEXT.md §2 and
// backend/docs/ARCHITECTURE.md §5). Kept as static display data here — the
// SERVER-side rate table (backend/src/services/computeCredit.js) is the
// source of truth for actual billing; this is presentation only. Prices are
// USD per the live billing catalog (backend/src/services/billing.js PLANS).
export const TIER_PLANS = [
  {
    id: 'payg',
    name: 'PAYG',
    price: '$0 / month',
    blurb: 'Pay only for the runs you make. No commitment.',
    popular: false,
    features: [
      'Full list rate — $0.80 CPU / $3.00 GPU per run',
      'All backtest modes (rules, signals, MC, walk-forward, portfolio)',
      'Live MSA data + {universe} African universe',
      'Top up anytime — no subscription',
    ],
    cta: 'Start with PAYG',
  },
  {
    id: 'analyst',
    name: 'Analyst',
    price: '$49 / month',
    blurb: 'The balanced plan for active research — 30% cheaper runs + $50 credit every month.',
    popular: true,
    features: [
      '$50 compute credit every month (≈ 89 CPU runs)',
      'CPU $0.56 / GPU $2.10 — 30% off list',
      'All backtest modes + ML research (train/sweep)',
      'Portfolio construction, screening & briefings',
      'Publish to the research marketplace',
      'Run history saved server-side',
    ],
    cta: 'Choose Analyst',
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$119 / month',
    blurb: 'For heavy research — 40% cheaper runs, 2.4× the credit, priority queue.',
    popular: false,
    features: [
      '$120 compute credit every month (≈ 250 CPU runs)',
      'CPU $0.48 / GPU $1.80 — 40% off list',
      'Everything in Analyst, plus GPU research',
      'Priority compute queue + full track-record ledger',
      'Priority support',
    ],
    cta: 'Go Pro',
  },
];

export function planCardClassName(popular) {
  return `aq-plan-card${popular ? ' aq-plan-card--popular' : ''}`;
}

export function universeCountLabel(count) {
  return Number.isInteger(count) && count >= 0 ? `${count}-stock` : 'supported';
}

export function planFeatures(plan, universeCount) {
  return (plan?.features || []).map((feature) =>
    feature.replace('{universe}', universeCountLabel(universeCount))
  );
}
